import { render, staticRenderFns } from "./ButtonsBlock.vue?vue&type=template&id=0c999f42&scoped=true&"
import script from "./ButtonsBlock.vue?vue&type=script&lang=js&"
export * from "./ButtonsBlock.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsBlock.vue?vue&type=style&index=0&id=0c999f42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c999f42",
  null
  
)

export default component.exports